import React from 'react';

type Props = {
  marginLeft?: number;
  marginRight?: number;
  separatorColor: string;
};

const Separator = ({ marginLeft = 0, marginRight = 0, separatorColor }: Props) => {
  return (
    <div
      style={{
        width: 1,
        height: '100%',
        backgroundColor: separatorColor,
        marginLeft,
        marginRight,
      }}
    />
  );
};

export default Separator;
